/** The desktop app's preload script exposes `electronAPI` on the wallet page. */
export const isElectron =
  typeof window !== "undefined" &&
  typeof (window as { electronAPI?: unknown }).electronAPI !== "undefined";
